export function processPaste(e, maxCharacterCount) {
    const pastedText = typeof(e?.clipboardData?.getData) === "function"? e.clipboardData.getData('text') : false;
    if (pastedText && maxCharacterCount) {
        const textarea = e.target;
        if (textarea) {
            e.preventDefault();
            const selectionStart = textarea.selectionStart;
            const selectionEnd = textarea.selectionEnd;
            const existingText = textarea.value;
            let finalText = existingText.slice(0, selectionStart) + pastedText + existingText.slice(selectionEnd);
            if (maxCharacterCount && finalText.length > maxCharacterCount) {
                finalText = finalText.slice(0, maxCharacterCount);
            }
            return finalText;
        }
    }
}